module.exports = __webpack_public_path__ + "assets/sounds/News-Alert03-1.mp3";